import React from "react";
import { ModalIntroLauncher } from "./ModalIntro";

//IMAGENES
import fb from "../img/footer/fb.png";
import ig from "../img/footer/ig.png";
import youtube from "../img/footer/youtube.png";
import logoguasasapo from "../img/footer/logoguasasapo.png";
import granada from "../img/footer/granada.png";
import comedora from "../img/footer/comedora.png";
import trincheta from "../img/footer/trincheta.png";
import guasasapotv from "../img/footer/guasasapotv.png";

const Footer = () => {
  return (
    <div className="footer">
      <div className="f1">
        <p>
          <b>GUASASAPO</b> cooperativa abierta<br></br> de arte y producción
        </p>
        <p>Santiago de Chile</p>
        <div className="logossocial">
          <a href="https://www.facebook.com/guasasapo" target="_blank" rel="noreferrer">
            <img src={fb} alt="link facebook"></img>
          </a>
          <a href="https://www.instagram.com/cooperativaguasasapo" target="_blank" rel="noreferrer">
            <img src={ig} alt="link instagram"></img>
          </a>
          <a
            href="https://www.youtube.com/channel/UCBcXgu-KiMKsyw9LUDYCFUw"
            target="_blank"
            rel="noreferrer"
          >
            <img src={youtube} alt="link youtube"></img>
          </a>
        </div>
      </div>
      <div className="f2">
        <a href="/guasasapo">
          <img src={logoguasasapo} alt="logo guasasapo"></img>
        </a>
        <div>
          <p>
            |
            <ModalIntroLauncher initialStep={1} label="Acceso y Uso" className="footerModalLink" />
            |
            <ModalIntroLauncher initialStep={2} label="Funcionamiento y autogestión" className="footerModalLink" />
            |
            <ModalIntroLauncher initialStep={4} label="Cómo apoyar GUASASAPOTV" className="footerModalLink" />
            |
          </p>
        </div>
      </div>
      <div className="f3">
        <a href="/comedora">
          <img src={comedora} alt="Comedora"></img>
        </a>
        <a href="/trincheta">
          <img src={trincheta} alt="Trincheta"></img>
        </a>
        <a href="/granada">
          <img src={granada} alt="Granada"></img>
        </a>
        <img src={guasasapotv} alt="Guasasapo TV"></img>
      </div>
    </div>
  );
};

export default Footer;
